const endpoints = {
	get: "/cart.json",
	add: "/cart/add.js",
	update: "/cart/update.js",
	change: "/cart/change.js",
};

const fetchCart = (shouldOpen = true) => {
  fetch(endpoints.get)
    .then(response => response.json())
    .then(data => {
      if(window.cartGwp) {
        const { items, total_price } = data;
        const { variant, threshold } = window.cartGwp;

        const itemIds = items.map(item => item.id);
        const hasGwp = itemIds.includes(window.cartGwp.variant);

        const shouldAddGwp = !hasGwp && total_price >= threshold && !localStorage.getItem('no_gwp');
        const shouldDeleteGwp = hasGwp && total_price < threshold;

        localStorage.removeItem('no_gwp');

        if(shouldAddGwp || shouldDeleteGwp) {
          shouldAddGwp && addToCart({ id: variant, quantity: 1, properties: { '_gwp': true } });
          shouldDeleteGwp && updateCart({ updates: { [variant]: 0 }});
          return;
        }
      }
      return data;
    })
    .then(data => {
      const elToggles = document.querySelectorAll('cart-toggle');
      const elCounts = document.querySelectorAll('[data-cart-count]');
      const elDrawer = document.querySelector('cart-drawer');

      elToggles.forEach(el => el.setAttribute('count', data.item_count));
      elCounts.forEach(el => el.innerHTML = `(${data.item_count})`);
      shouldOpen && elDrawer.setAttribute('open', true);

      window.cart = data;
      window.renderCart();

      return data;
    })
    .catch(err => {
      console.log(err);
      return err
    });
}

const postCart = async (data, endpoint) => {
  console.log('post data is ', data);
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  const json = await response.json();
  response.ok && fetchCart();
  return json;
};

window.addToCart = (data) => postCart(data, endpoints.add);
window.updateCart = (data) => postCart(data, endpoints.update);

const formatMoney = (number, precision = 2, thousands = ',', decimal = '.') => {
  if (isNaN(number) || number == null) {
    return 0;
  }

  if (precision == 0 && (number / 100.0) % 1 != 0) {
    number = (number / 100.0).toFixed(2);
  } else {
    number = (number / 100.0).toFixed(precision);
  }

  const { active: activeCurrency } = window.Shopify.currency;
  const currencySymbol =  window.currencies && window.currencies[activeCurrency] ? window.currencies[activeCurrency] : '$';

  let parts = number.split(".");
	let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `${currencySymbol}1` + thousands);
  let cents = parts[1] ? decimal + parts[1] : "";

  return `${currencySymbol}${dollars + cents}`;
}

class CartDrawer extends PopupModal {
  constructor() {
    super();

    this.elCrossSells = this.querySelector('[data-crosssells]');
    this.elContent = this.querySelector('[data-content]');

    this.open = this.getAttribute('open') == 'true';

    this.progressBars = JSON.parse(this.getAttribute('progress-bars'));
    this.enableGiftNote = this.getAttribute('gift-note') == 'true';
    this.crossSells = this.elCrossSells ? JSON.parse(this.elCrossSells.innerHTML) : null;
    this.crossSellProducts = [];
    
    fetchCart(false);
    this.bind();

    window.toggleCart = this.toggleDrawer.bind(this);
    window.renderCart = this.renderCart.bind(this);
  }

  renderCart() {
    const { item_count, total_price } = window.cart;
    const isEmpty = item_count == 0;
    const enabledProgressBars = Object.keys(this.progressBars).filter(key => this.progressBars[key].enabled).map(key => this.progressBars[key]);
 
    this.elContent.innerHTML = `
      <div class="cart-drawer--header">
        <div class="cart-drawer--header-top">
          <h2 class="cart-drawer--heading h4">
            Your Bag <span class="visually-hidden">has</span> <span data-cart-count>(${item_count})</span> <span class="visually-hidden">items</span>
          </h2>
          <button 
            type="button"
            aria-label="Close cart drawer"
            aria-haspopup="true"
            aria-controls="cart-drawer"
            class="cart-drawer--close btn--close"
            data-close
          ></button>
        </div>
        ${enabledProgressBars.length ? `
          <div class="cart-drawer--header-bottom">
            ${enabledProgressBars.map(bar => this.progressTemplate(bar)).join('')}
          </div>
        ` : ''}
      </div>
      <div class="cart-drawer--body">
        ${isEmpty ? this.emptyTemplate() : this.itemsTemplate()}
      </div>
      <form
        id="cart-form"
        action="/cart"
        method="post"
        class="cart-drawer--footer"
      >
        <div class="cart-drawer--subtotal">
          <h3 class="cart-drawer--subtotal-heading">Subtotal:</h3>
          <strong class="cart-drawer--subtotal-value">${formatMoney(total_price)}</strong>
        </div>
        <input type="hidden" value="checkout" name="checkout" />
        <button type="submit" class="cart-form--submit btn--add" ${isEmpty ? 'disabled' : ''}>
          Checkout 
        </button>
        ${!isEmpty && this.enableGiftNote ? this.giftNoteTemplate() : ''}
        <div class="route-div" watch-changes=".cart-drawer--body" desktop-align="center"></div>
      </form>
    `
    this.bind();
  }

  progressTemplate(progressBar) {
    const distanceToThreshold =  progressBar.threshold - window.cart.total_price;
    const thresholdMet = distanceToThreshold <= 0;
    const label = thresholdMet ? progressBar.success_message : progressBar.progress_message.replace('distance_to_threshold', formatMoney(distanceToThreshold));

    return !progressBar.success_message && thresholdMet ? '' : `
      <div class="cart-drawer--progress">
        <label for="shipping-bar" class="cart-drawer--progress-label small">
          ${label}
        </label>
        <progress
          id="shipping-bar"
          max="${progressBar.threshold}"
          value="${window.cart.total_price}"
          class="cart-drawer--progress-bar ${progressBar.hide_progress ? 'visually-hidden' : ''}"
        >
          ${formatMoney(window.cart.total_price)}
        </progress>
      </div>
    `
  }

  emptyTemplate() {
    return `
      <div class="cart-drawer--empty">
        <p>Your shopping bag feels empty</p>
        <a href="/collections/all" class="btn">
          Shop <span class="visually-hidden">the full product collection</span> Now
        </a>
      </div>
    `
  }

  itemsTemplate() {
    const { items } = window.cart;
    const itemIds = items.map(item => item.product_id);
    this.crossSellProducts = this.crossSells ? Object.keys(this.crossSells).filter(key => !itemIds.includes(Number(key)) && key).map(key => this.crossSells[key]) : [];

    return `
      <ul class="cart-drawer--items">
        ${items.map(item => {
          const variantTitle = item.variant_title && item.variant_title != 'Default Title' ? item.variant_title.includes('(') ? item.variant_title.split(' (')[0] : item.variant_title : null;
          const isGwp = item.properties?._gwp || false;
          return `<li class="cart-drawer--item small ${isGwp ? 'gwp' : ''}">
            <div class="cart-drawer--item-info">
              <div class="cart-drawer--item-heading">
                <h3 class="cart-drawer--item-title">
                  ${item.product_title}
                </h3>
                <strong class="cart-drawer--item-price">
                  ${isGwp ? 'FREE' : `
                    ${item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price ? `<s>${formatMoney(item.selling_plan_allocation.compare_at_price * item.quantity)}</s>` : item.original_line_price > item.final_line_price ? `<s>${formatMoney(item.original_line_price)}</s>` : ''}
                    ${formatMoney(item.final_line_price)}
                  `}
                </strong>
              </div>
              ${variantTitle || item.selling_plan_allocation ? `
                <p>${variantTitle ? variantTitle : ''} ${item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : ''}</p>
              ` : ''}
              ${item.properties && item.properties._promotion ? `<p>${item.properties._promotion}</p>` : ''}
              <div class="cart-drawer--item-actions">
                ${!isGwp ? `
                  <quantity-picker
                    quantity="${item.quantity}"
                    data-name="updates[]"
                    data-id="${item.key}"
                    data-title="${item.title}"
                  ></quantity-picker>
                ` : ''}
                <button
                  type="button"
                  class="cart-drawer--item-remove"
                  data-id="${item.key}"
                  data-gwp="${isGwp}"
                  data-remove
                >
                  Remove
                </button>
              </div>
            </div>
            <div class="cart-drawer--item-image overlay-link--parent">
              <img
                src="${item.image}"
                alt="An image of ${item.title}"
                width="100"
                height="100"
                class="cover"
              />
              ${!isGwp ? `
                <a href="${item.url}" class="overlay-link">
                  View more information about ${item.title}
                </a>
              ` : ''}
            </div>
          </li>`
        }).join('')}
      </ul>
      ${this.crossSellProducts.length ? this.crossSellsTemplate() : ''}
    `
  }

  giftNoteTemplate() {
    const giftNote = window.cart.attributes['gift-message'];
    return `
      <div class="cart-drawer--gift small ${giftNote ? 'has-gift' : ''}" data-gift>
        <div class="cart-drawer--gift-label no-gift">
          Buying as a Gift? <button type="button" data-gift-add>Add a Gift Message</button>
        </div>
        <div class="cart-drawer--gift-label has-gift">
          <button type="button" data-gift-remove>Remove Gift Message</button>
        </div>
        <textarea
          id="cart-gift-note"
          name="attributes[gift-message]"
          maxlength="255"
          aria-label="Gift message"
          placeholder="Your message (255 character limit)..."
          class="cart-drawer--gift-message"
        >${giftNote ? giftNote : ''}</textarea>
      </div>
    `
  }
  
  crossSellsTemplate() {
    return `
      <div class="cart-drawer--crosssells swiper" data-cart-crosssells>
        <div class="cart-drawer--crosssells-header">
          <h3 class="cart-drawer--crosssells-heading">
            ${this.getAttribute('cross-sell-heading')}
          </h3>
          <div class="cart-drawer--crosssells-nav">
            <button
              type="button"
              class="btn--prev"
              data-crosssellss-prev
            >
              <span class="visually-hidden">View previous product</span>
            </button>
            <button
              type="button"
              class="btn--next"
              data-crosssellss-next
            >
              <span class="visually-hidden">View next slide</span>
            </button>
          </div>
        </div> 
        <div class="cart-drawer--crosssells-products swiper-wrapper">
          ${this.crossSellProducts.map(product => product).join('')}
        </div>
      </div>
    `
  }

  bind() {
    this.elClose = this.querySelectorAll('[data-close]');
    this.elClose.forEach(el => {
      el.onclick = this.toggleDrawer.bind(this);
    });

    this.elQuantity = this.querySelectorAll('quantity-picker');
    this.elQuantity.forEach(el => {
      el.onchange = () => {
        const data = { updates: { [el.dataset.id]: el.querySelector('input').value } };
        el.setAttribute('loading', true);
        window.updateCart(data)
          .then(response => {
            el.setAttribute('loading', false);
          });
      }
    });

    this.elRemove = this.querySelectorAll('[data-remove]');
    this.elRemove.forEach(el => {
      el.onclick = () => {
        const data = { updates: { [el.dataset.id]: 0 }};
        const isGwp = el.dataset.gwp == "true";
        window.updateCart(data)
        isGwp && window.setStorageItem('no_gwp', true, 1);
      }
    });

    this.crossSellSwiper = window.Swiper && new window.Swiper('[data-cart-crosssells]', {
      loop: this.crossSellProducts.length > 2,
      slidesPerView: 2,
      spaceBetween: 16,
      navigation: {
        nextEl: '[data-crosssellss-next]',
        prevEl: '[data-crosssellss-prev]'
      }
    });

    this.elGift = this.querySelector('[data-gift]');
    if(this.elGift) {
      this.elGiftNoteAdd = this.elGift.querySelector('[data-gift-add]');
      this.elGiftNoteAdd.onclick = () => this.elGift.classList.add('has-gift');

      this.elGiftNoteInput = this.elGift.querySelector('textarea');
      this.elGiftNoteInput.onchange = (ev) => {
        updateCart({ attributes: { 'gift-message': ev.currentTarget.value }});
      }

      this.elGiftNoteRemove = this.elGift.querySelector('[data-gift-remove]');
      this.elGiftNoteRemove.onclick = () => {
        const giftNote = window.cart.attributes['gift-message'];
        this.elGift.classList.remove('has-gift');
        this.elGiftNoteInput.value = '';
        giftNote && updateCart({ attributes: { 'gift-message': '' } });
      }
    }
    
    window.initLazyLoad && window.initLazyLoad();
  }

  toggleDrawer(ev) {
    ev && ev.preventDefault();
    this.open = !this.open;
    this.setAttribute('open', this.open);
  }
}

customElements.define('cart-drawer', CartDrawer);